import type { ToolMeta } from "../types";

export const toolMeta = {
  slug: "lorem-ipsum-generator",
  title: "Lorem Ipsum Generator",
  description:
    "Generate Lorem Ipsum placeholder text by paragraph, sentence, or word count and copy it quickly.",
  category: "Text",
} satisfies ToolMeta;
